/**
 * Dynamic Mega Menu Image Switcher
 * Changes promotion image based on hovered menu item
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenuImageSwitcher);
  } else {
    initMegaMenuImageSwitcher();
  }

  function initMegaMenuImageSwitcher() {
    const megaMenus = document.querySelectorAll('.mega-menu-container');
    
    megaMenus.forEach(function(megaMenu) {
      // Find the promotion image container
      const promoImage = megaMenu.querySelector('.mega-menu-promotion--image img');
      
      if (!promoImage) return;
      
      // Store original image
      const originalSrc = promoImage.src;
      
      // Get all menu items with images
      const menuItems = megaMenu.querySelectorAll('[data-menu-item], [data-menu-subitem]');
      
      menuItems.forEach(function(item) {
        const imageUrl = item.getAttribute('data-collection-image');
        
        if (!imageUrl) return;
        
        // On hover - change image
        item.addEventListener('mouseenter', function() {
          promoImage.style.opacity = '0';
          
          setTimeout(function() {
            promoImage.src = imageUrl;
            promoImage.srcset = imageUrl;
            promoImage.style.opacity = '1';
          }, 200);
        });
      });
      
      // Reset to original on menu leave
      megaMenu.addEventListener('mouseleave', function() {
        promoImage.style.opacity = '0';
        
        setTimeout(function() {
          promoImage.src = originalSrc;
          promoImage.style.opacity = '1';
        }, 200);
      });
    });
  }
})();